// extracted by mini-css-extract-plugin
module.exports = {"dot_flashing":"FlashingDots_dot_flashing__319RR","dotFlashing":"FlashingDots_dotFlashing__1bIXL"};